import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Container = styled(View, {
  base: {
    flex: 1,
  },
})
